const externalLinks = document.querySelectorAll('a');

if (externalLinks) {
  [...externalLinks].forEach((linkEl) => {
    if (!linkEl.hostname) {
      return;
    }

    if (linkEl.hostname !== window.location.hostname || linkEl.pathname.includes('/donate/')) {
      linkEl.setAttribute('target', '_blank');
      linkEl.setAttribute('rel', 'noopener noreferrer');
    }
  });
}
